import { BaseRouteService } from 'core/services';

class ReportingIntervalTypeRouteService extends BaseRouteService {
    constructor() {
        super('reporting-interval-types');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp}', filter);
    }
  
}

export default ReportingIntervalTypeRouteService;
